export const appName = "Logtech";
